/* eslint-disable arrow-body-style */
/* eslint-disable no-return-await */
import axios from 'axios';
import store from '@/store';
import utils from './utils';

const API_USER_INFO = `${utils.svcUrl()}user-info`;

// ////////////
// API Wrappers
// ////////////
const userInfoApi = {
  getUserInfo: async (userId) => {
    // console.log('In userInfoApi.getUserInfo');
    return await axios.get(API_USER_INFO, {
      params: { userId },
    });
  },
  syncUserEmail: async (acctUsername) => {
    // console.log('In userInfoApi.syncUserEmail');
    return await axios.get(`${API_USER_INFO}/sync-email`, {
      params: { acctUsername },
    });
  },
  updateconfiguration: async (data) => {
    return await axios.post(`${API_USER_INFO}/update/configuration`, data);
  },
  verifydomain: async (data) => {
    return await axios.post(`${API_USER_INFO}/checkDNS`, data);
  },
  setUserSubscriptions: async (userId, chSubscriptions) => {
    // console.log('In userInfoApi.setUserSubscriptions');
    return await axios.post(API_USER_INFO, {
      userId,
      chSubscriptions,
    });
  },
  setUserAcctInfo: async (userId, userName, userEmail) => {
    // console.log('In userInfoApi.setUserAcctInfo');
    return await axios.post(API_USER_INFO, {
      userId,
      userName,
      userEmail,
    });
  },
  addNewUserInfo: async (userId, userName, acctUsername, userEmail, tz, locale) => {
    return await axios.post(`${API_USER_INFO}/new-user`, {
      userId,
      userName,
      acctUsername,
      userEmail,
      tz,
      locale,
    });
  },
  // newUserInfo: async (userId, userName, acctUsername, userEmail, chSubscriptions, tz, locale) => {
  //   // console.log('In userInfoApi.newUserInfo');
  //   return await axios.post(`${API_USER_INFO}/new`, {
  //     userId, userName, acctUsername, userEmail, chSubscriptions, tz, locale,
  //   });
  // },
  newUserInfoUsingSync: async (cogUsername, tz, locale) => {
    // console.log('In userInfoApi.newUserInfoUsingSync');
    return await axios.post(`${API_USER_INFO}/new-user-sync`, {
      cogUsername,
      tz,
      locale,
    });
  },
  onboardMember: (topicId) => {
    return axios.post(`${API_USER_INFO}/onboard-member`, { topicId });
  },
  getTopicPermission: (topicId) => {
    return axios.get(`${API_USER_INFO}/topic-permission`, { params: { topic: topicId } });
  },
  getEnrolledStudents: (courseId) => {
    return axios.get(`${API_USER_INFO}/enrolled-students/${courseId}`);
  },
  getCoursecreators: () => {
    return axios.get(`${API_USER_INFO}/course-creators`);
  },
  getuseractivities: (userId) => {
    return axios.get(`${API_USER_INFO}/course-lesson-activity-logs/${userId}`);
  },
  removestudent: (data) => {
    return axios.post(`${API_USER_INFO}/remove-student`, data);
  },
  enrollUser: (data) => {
    return axios.post(`${API_USER_INFO}/enrollUser`, data);
  },
  getfiltredactivity: (data) => {
    return axios.post(`${API_USER_INFO}/filter/activitylogs`, data);
  },
};

// ////////////
// Utils
// ////////////

// ////////////
// Model State
// ////////////
let _userId = null;
let _chSubs = [];

// ////////////
// Model Accessors
// ////////////
export default {
  clear() {
    _userId = null;
    _chSubs = [];
  },
  async getUserInfo(userId) {
    if (!userId) {
      console.log('Cant do getUserInfo with no userId');
      return {};
    }
    _userId = userId;
    const getResults = await userInfoApi.getUserInfo(userId);
    return getResults.data;
  },
  async syncUserEmail(acctUsername) {
    if (!acctUsername) {
      console.log('Cant do syncUserEmail with no acctUsername');
      return {};
    }
    const getResults = await userInfoApi.syncUserEmail(acctUsername);
    return getResults.data;
  },
  async getSubscriptions(userId) {
    if (!userId) {
      console.log('Cant do getSubscriptions with no userId');
      return [];
    }
    if (userId === _userId) return _chSubs;
    _userId = userId;
    const userInfo = await (await userInfoApi.getUserInfo(userId)).data;
    // const userInfo = getResults.data;
    // console.log('Reading userInfo: ', userInfo);
    if (userInfo.chSubscriptions) _chSubs = userInfo.chSubscriptions;
    else _chSubs = [];
    return _chSubs;
  },
  async addSubscriptions(subItem, cmp = null) {
    if (_chSubs.indexOf(subItem) === -1) {
      _chSubs.push(subItem);
      if (cmp) store.state.chSubscriptions = _chSubs;
      if (_userId) await userInfoApi.setUserSubscriptions(_userId, _chSubs);
    }
  },
  isSubscribed(subItem) {
    if (_chSubs.indexOf(subItem) === -1) return false;
    return true;
  },
  async remSubscriptions(subItem, cmp = null) {
    const subNdx = _chSubs.indexOf(subItem);
    if (subNdx !== -1) {
      _chSubs.splice(subNdx, 1); // remove item
      if (cmp) store.state.chSubscriptions = _chSubs;
      if (_userId) await userInfoApi.setUserSubscriptions(_userId, _chSubs);
    }
  },
  async setAcctInfo(userName, userEmail) {
    if (_userId) await userInfoApi.setUserAcctInfo(_userId, userName, userEmail);
  },
  // used as part of the account creation workflow - which is why userId has not been set yet
  async setAcctInfoForUserId(userId, userName, userEmail) {
    if (userId) await userInfoApi.setUserAcctInfo(userId, userName, userEmail);
  },
  // async createNewUser(userId, userName, acctUsername, userEmail) {
  //   if (!userId || !userName || !acctUsername || !userEmail) {
  //     console.log('Cant do createNewUser with no userId, userName, acctUserName, or userEmail');
  //     return;
  //   }
  //   this.clear();
  //   _userId = userId;
  //   const tz = new Date().getTimezoneOffset() / 60;
  //   const locale = (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.language;
  //   await userInfoApi.newUserInfo(userId, userName, acctUsername, userEmail, [], tz, locale);
  // },
  async createNewUserUsingSync(cogUsername) {
    if (!cogUsername) {
      console.log('Cant do createNewUser2 with no cogUsername');
      return;
    }
    this.clear();
    const tz = new Date().getTimezoneOffset() / 60;
    const locale =
      navigator.languages && navigator.languages.length
        ? navigator.languages[0]
        : navigator.language;
    await userInfoApi.newUserInfoUsingSync(cogUsername, tz, locale);
  },
  async createNewUser(userId, userName, acctUsername, userEmail) {
    if (!userId) {
      console.log('Cant do add-new-user with no userId');
      return;
    }
    this.clear();
    const tz = new Date().getTimezoneOffset() / 60;
    const locale =
      navigator.languages && navigator.languages.length
        ? navigator.languages[0]
        : navigator.language;
    await userInfoApi.addNewUserInfo(userId, userName, acctUsername, userEmail, tz, locale);
  },
  async onboardMember(topicId) {
    if (!topicId) {
      return { message: 'Something wrong with the invite link' };
    }
    const result = await userInfoApi.onboardMember(topicId);
    return result;
  },
  async updateconfiguration(data) {
    const result = await userInfoApi.updateconfiguration(data);
    return result;
  },
  async verifydomain(data) {
    const result = await userInfoApi.verifydomain(data);
    return result;
  },
  async getTopicPermission(topicId) {
    const result = await userInfoApi.getTopicPermission(topicId);
    if (result.status !== 200) {
      return null;
    }
    return result.data;
  },
  async getEnrolledStudents(courseId) {
    const result = await userInfoApi.getEnrolledStudents(courseId);
    if (result.status !== 200) {
      return null;
    }
    return result.data;
  },
  async getCoursecreators() {
    const result = await userInfoApi.getCoursecreators();
    if (result.status !== 200) {
      return null;
    }
    return result.data;
  },
  async getuseractivities(userId) {
    const result = await userInfoApi.getuseractivities(userId);
    if (result.status !== 200) {
      return null;
    }
    return result.data;
  },
  async getfiltredactivity(data) {
    const result = await userInfoApi.getfiltredactivity(data);
    return result.data;
  },
  async removeStudent(data) {
    const result = await userInfoApi.removestudent(data);
    return result.data;
  },
  async enrollUser(data) {
    const result = await userInfoApi.enrollUser(data);
    return result.data;
  },
};
